export default __webpack_public_path__ + "static/media/sent_successfully.810f7807.png";